import { Fragment } from 'react';
import AccordionResidence from 'cohabitation/components/shared/residence';
import AccordionGenerality from 'cohabitation/components/shared/generality';
import AccordionDataCohabitationResponsible from '../shared/data-cohabitation-responsible';
import AccordionCohabitaton from './accordion-cohabitation';

interface CohabitationDetailStepProps {
  stepState: number;
}

const CohabitatonDetailStep = ({ stepState }: CohabitationDetailStepProps): React.ReactElement => {
  return (
    <Fragment>
      {stepState === 0 ? (
        <>
          <AccordionCohabitaton />
        </>
      ) : undefined}
      {stepState === 1 ? (
        <>
          <AccordionResidence />
        </>
      ) : undefined}
      {stepState === 2 ? (
        <>
          <AccordionGenerality />
          <AccordionDataCohabitationResponsible />
        </>
      ) : undefined}
    </Fragment>
  );
};

CohabitatonDetailStep.displayName = 'Cohabitation Detail step component';

export default CohabitatonDetailStep;
